/**
 * Parse clipboard text into a two-field digit code (e.g. `"482-917"` →
 * `{ left: "482", right: "917", matched: true }`). Returns `matched: false`
 * when the input doesn't contain enough digits to fill both fields —
 * callers should let the browser's default paste behaviour run in that
 * case.
 */
export const splitPastedCode = (
	text: string,
	leftLength = 3,
	rightLength = 3
): { left: string; right: string; matched: boolean } => {
	const digits = text.replace(/\D/g, '');
	const total = leftLength + rightLength;
	if (digits.length < total) {
		return { left: '', right: '', matched: false };
	}
	return {
		left: digits.slice(0, leftLength),
		right: digits.slice(leftLength, total),
		matched: true,
	};
};
